// The phrases a learner can keep from the stories. They are reviewed like course phrases (hear-it
// cards), but they belong to no lesson and never come up as new phrases on their own.

import type { Item, Staff } from '../content/types';
import words from './generated/words.json';

export const storyItems = words as Item[];

const ids = new Set(storyItems.map((i) => i.id));

export function isStoryItem(id: string): boolean {
  return ids.has(id);
}

/** Who says a story phrase in a review: the narrator, a woman. */
export const STORY_STAFF: Staff = { role: 'Narrator', cast: null, voice: 'female' };
